import { QueryClient } from '@tanstack/react-query';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        gcTime: 0,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        retry: 0
      }
    }
  });
}

export const appQueryClient = createQueryClient();
